'use strict';

import $ from 'jquery';
import enquire from 'enquire.js';
import 'jquery-match-height';
import 'slick-carousel';

export default class SocialFeed {
  constructor(config) {
    let { breakpoints } = config;
    let $socialFeed = $('.social-feed');
    let $content = $('.social-feed__content', $socialFeed);
    let $items = $('.social-feed__item', $socialFeed);
    let $tripadvisor = $('.tripadvisor');
    let $heightItem1 = $items.eq(0).height();
    let $heightItem2 = $items.eq(1).height();


    this.$content = $content;
    this.$items = $items;

    let resizeTimeout;
    
    enquire.register(`screen and (min-width:${ breakpoints.desktop }px)`, {
      match: () => {
        // store original height of box
        
        $(window).on('resize.socialFeed', e => {
          clearTimeout(resizeTimeout);

          resizeTimeout = setTimeout(() => {
            this.adjustCardHeight();
          }, 100);
        });

        $(window).on('load', () => {
          $(window).trigger('resize.socialFeed');
        });

        $tripadvisor.css({
          height: $heightItem1 + $heightItem2 + 30
        });

      },
      unmatch: () => {
        clearTimeout(resizeTimeout);
        $(window).off('resize.socialFeed');
        this.removeCardHeight();
      }
    });

    enquire.register(`screen and (min-width:${ breakpoints.tablet }px) and (max-width: ${ breakpoints.desktop -1}px)`, {
      match: () => {
        this.$items.matchHeight();
      },
      unmatch: () => {
        this.$items.matchHeight({ remove: true});
      }
    });

    //social feed slide
    let $socialSlide = $('.social-post-slider');

    $socialSlide.slick({
      infinite: false,
      arrows: false,
      autoplay: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });

  }
  adjustCardHeight() {

    this.originalHeight = this.$items.map((i, item) => {
      let $item = $(item);
      $item.css({
        height: 'auto'
      });

      return $item.outerHeight();
    });

    if (this.originalHeight[2] > (this.originalHeight[0] + this.originalHeight[1] + 10)) {
      // 1st box > 2nd + 3rd box height + padding
      this.$items.eq(0).css({
        height: (this.originalHeight[2] - 10) / 2
      });
      this.$items.eq(1).css({
        height: (this.originalHeight[2] - 10) / 2
      });
      // this.$items.eq(3).css({
      //   height: (this.originalHeight[2] - 30) / 2
      // });
      // this.$items.eq(4).css({
      //   height: (this.originalHeight[2] - 30) / 2
      // });
      // this.$items.eq(5).css({
      //   height: (this.originalHeight[2] - 30) / 2
      // });
      // this.$items.eq(6).css({
      //   height: (this.originalHeight[2] - 30) / 2
      // });
      
      } else {
        this.$items.eq(2).css({
          height: this.originalHeight[0] + this.originalHeight[1] + 2
        });
        let largeItem = this.$items.eq(2).height();
        let largeImg = this.$items.eq(2).find('.social-post__image');
        largeImg.css("height", largeItem);
    }
   
  }

  removeCardHeight() {
    $('.social-feed__item').css({
      height: 'auto'
    });
  }
}
